import { useCustomQuery } from "data/modules/api/hooks/useCustomQuery";
import { statusCodes } from "../../modules/EmailSenderIDs/constants/EmailSender.constants";
import { EMAIL_SENDER_API_END_POINT } from "features/Integration/modules/EmailSenderIDs/constants/API";

export const useGetCustomEmails = () => {
  return useCustomQuery({
    queryKey: EMAIL_SENDER_API_END_POINT.list,
    url: EMAIL_SENDER_API_END_POINT.list,
    params: {
      status: statusCodes.sender_id_approved,
    },
  });
};
